// eslint-disable-next-line import/no-cycle
import TextBlockGroup from './TextBlockGroup';

export default TextBlockGroup;
